module.exports = __webpack_public_path__ + "img/iconmonstr-link-7.ba2d048d.svg";